









































import {Component, Prop} from "vue-property-decorator"
import AbpBase from "@/lib/abpbase"
import {GetDicsByCode} from "@/api/systemBasic"
import {GetPropaganda} from "@/api/propaganda"


@Component({
	components: {}
})
export default class Warehouse extends AbpBase {
	@Prop({type: Boolean, default: false}) value: Boolean
	@Prop({type: Array, default: []}) selectIds: Array<any>
	data: any = [] // 全部
	items: any = [] // 过滤过后的结果

	spinShow: Boolean = false

	query: any = {
		QueryString: '',
		Type: '全部'
	}
	types: any = []


	async created() {
		console.log(this.selectIds)
		await this.getSelects()
		this.getData()
	}
	save() {
		let arr = this.data.filter((item:any) => {
			return item.checked
		})
		console.log(arr)
		this.$emit('save-success', arr)
	}
	typeClick(type: String) {
		this.query.Type = type
		this.getData()
	}
	cancel(){
		this.$emit('input', false)
	}
	async getSelects() {
		let res = await GetDicsByCode({code: 'Propaganda_Type'})
		this.types = res.objects
	}

	async getData() {
		// 后台接口啥也没有过滤
		// 只有全部时获取后台，不然直接过滤全部数据
		this.spinShow = true
		if (this.query.Type === "全部") {
			let res = await GetPropaganda({})
			// 过滤掉已存在
			this.data = res.objects.filter((item:any)=>{
				// 添加一个属性为checked
				item.checked = false
				return this.selectIds.indexOf(item.id) === -1
			})
			// 过滤检索字符
			this.items = this.data.filter((item: any) => {
				return item.resourceTitle.indexOf(this.query.QueryString) !== -1
			})
		} else {
			this.items = this.data.filter((item: any) => {
				return item.type.indexOf(this.query.Type) !== -1 && item.resourceTitle.indexOf(this.query.QueryString) !== -1
			})
		}
		this.spinShow = false
	}
	visibleChange(value: boolean) {
		if (!value) {
			this.$emit('input', value);
		}
	}
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/education/educationPlan/parts/edu.vue